export const SSID_SCHEDULE_SECTION_EVENT =
	'canvas-agent:ssid-schedule:section';
export const SSID_SCHEDULE_FILTER_EVENT =
	'canvas-agent:ssid-schedule:filter';
export const SSID_SCHEDULE_FOCUS_EVENT =
	'canvas-agent:ssid-schedule:focus';
export const SSID_SCHEDULE_CREATE_MODAL_EVENT =
	'canvas-agent:ssid-schedule:create-modal';
export const SSID_SCHEDULE_EDIT_MODAL_EVENT =
	'canvas-agent:ssid-schedule:edit-modal';
export const SSID_SCHEDULE_DELETE_MODAL_EVENT =
	'canvas-agent:ssid-schedule:delete-modal';
